<div
  data-test="HXg99Qz4"
  class="login__form"
  *ngIf="loginForm$ | async | notNull as loginForm"
>
  <div data-test="gwVLJbK-" class="login__form-header">
    <h1 data-test="ZZ-kssvJ">Forgot password</h1>
    <p data-test="7N6Fh4--">
      Enter your email address below and we'll get you back to business.
    </p>
  </div>
  <form
    data-test="hOuVOUMx"
    class="form form_account"
    [ngrxFormState]="loginForm"
    (submit)="sendResetLink()"
  >
    <div data-test="r_2m3HI1" *ngIf="loginForm.errors.$notFound" class="form__error">
      User with this email not found.
    </div>
    <div
      data-test="HBD2nMQN"
      class="form-group"
      [class.error]="
        loginForm.controls.username.isInvalid && loginForm.controls.username.isDirty
      "
    >
      <label data-test="THhEzL2_" class="form-group__label" for="input-1">E-mail</label>
      <input
        data-test="LiVp7HXV"
        class="input"
        id="input-1"
        type="email"
        [ngrxFormControlState]="loginForm.controls.username"
        placeholder="john@macs.com"
      />
    </div>
    <div data-test="DsWC3RXq" class="form-group">
      <button data-test="ZmAzQKBF" class="form-submit button button_primary w-100">
        Request reset link
      </button>
    </div>
  </form>
</div>
<footer data-test="vOh1qVOn" class="login__right-footer text-center">
  <a data-test="9YtnPkMU" class="link text-small" [routerLink]="['../login']">
    Back to login
  </a>
</footer>
